var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMassiveLoadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.93068 17.3837C7.51115 17.3837 7.16324 17.0358 7.16324 16.6163V12.3288L6.42649 13.0656C6.12975 13.3623 5.63859 13.3623 5.34184 13.0656C5.0451 12.7688 5.0451 12.2777 5.34184 11.9809L7.38836 9.93443C7.60324 9.71954 7.94091 9.64792 8.22743 9.77071C8.51394 9.88327 8.69812 10.1698 8.69812 10.4768V16.6163C8.69812 17.0358 8.35022 17.3837 7.93068 17.3837Z",
    fill: "#F5F6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.97716 13.2906C9.78274 13.2906 9.58833 13.219 9.43484 13.0655L7.38836 11.019C7.09161 10.7222 7.09161 10.2312 7.38836 9.93443C7.6851 9.63768 8.17626 9.63758 8.47301 9.93433L10.5195 11.9808C10.8162 12.2776 10.8162 12.7687 10.5195 13.0655C10.366 13.219 10.1716 13.2906 9.97716 13.2906Z",
    fill: "#F5F6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0698 22.5H7.93024C2.37396 22.5 0 20.1261 0 14.5698V8.43024C0 2.87396 2.37396 0.5 7.93024 0.5H13.0465C13.4661 0.5 13.814 0.847907 13.814 1.26744C13.814 1.68698 13.4661 2.03489 13.0465 2.03489H7.93024C3.21303 2.03489 1.53489 3.71303 1.53489 8.43024V14.5698C1.53489 19.287 3.21303 20.9651 7.93024 20.9651H14.0698C18.787 20.9651 20.4651 19.287 20.4651 14.5698V9.4535C20.4651 9.03396 20.813 8.68606 21.2326 8.68606C21.6521 8.68606 22 9.03396 22 9.4535V14.5698C22 20.1261 19.6261 22.5 14.0698 22.5Z",
    fill: "#F5F6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2326 10.2209H17.1396C13.64 10.2209 12.2791 8.86 12.2791 5.36046V1.26743C12.2791 0.960455 12.4633 0.673943 12.7498 0.561385C13.0363 0.438594 13.3637 0.510222 13.5889 0.725106L21.7749 8.91116C21.9898 9.12605 22.0614 9.46373 21.9386 9.75024C21.8158 10.0368 21.5396 10.2209 21.2326 10.2209ZM13.814 3.11953V5.36046C13.814 8.00046 14.4996 8.68604 17.1396 8.68604H19.3805L13.814 3.11953Z",
    fill: "#F5F6FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMassiveLoadIcon);
export default __webpack_public_path__ + "static/media/massive-load-icon.ddaa2eb02d61a505c71b3f1be0437c3d.svg";
export { ForwardRef as ReactComponent };